var site = site || {};

(function ($) {
  Drupal.behaviors.foundationFinderQuizCarouselV3 = {
    isMobile: false,
    isMedium: false,

    attach: function (context) {
      var self = this;
      var $formatters = $(self.selector.formatter, context);

      if ((Unison.fetch.now())) {
        self.checkDevice();
      }
      $formatters.each(function () {
        var $this = $(this);

        Unison.on('change', function () {
          var isDesktop = !self.isMobile && !self.isMedium;

          self.checkDevice();
          if (isDesktop !== !self.isMobile && !self.isMedium) {
            self.swapLayout($this);
          }
        });
        self.setup($this);
      });
    },
    checkDevice: function () {
      var self = this;

      self.isMobile = self.checkIfMobile();
      self.isMedium = self.checkIfMedium();
    },
    selector: {
      formatter: '.js-foundation-finder__carousel-formatter',
      modelsCarousel: '.js-foundation-finder__models-carousel',
      modelsSlide: '.js-foundation-finder__models-slide',
      modelsArrows: '.js-foundation-finder__models-carousel-arrows',
      shadeCarousel: '.js-foundation-finder__shade-carousel',
      container: '.js-foundation-finder--quiz-carousel',
      quizSlide: '.js-foundation-finder--quiz-slide',
      quiz: '.js-foundation-finder--quiz'
    },

    modelsSettings: {
      rtl: site.direction.isRTL,
      speed: 750,
      infinite: false,
      arrows: true,
      accessibility: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: '.js-foundation-finder__models-carousel-arrows',
      initialSlide: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            speed: 300
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            speed: 300
          }
        }
      ]
    },

    shadeSettings: {
      speed: 950,
      infinite: false,
      arrows: false,
      swipe: false,
      draggable: false,
      touchMove: false,
      accessibility: false,
      slidesToScroll: 1,
      centerMode: false
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$container = $that.closest(self.selector.container);
      $that.nodes.$quizSlide = $that.closest(self.selector.quizSlide);
      $that.nodes.$quiz = $that.closest(self.selector.quiz);
      $that.nodes.$modelsCarousel = $(self.selector.modelsCarousel, $that);
      $that.nodes.$modelsSlides = $(self.selector.modelsSlide, $that);
      $that.nodes.$shadeCarousel = $(self.selector.shadeCarousel, $that);
      $that.nodes.$modelsArrows = $(self.selector.modelsArrows, $that);
    },

    setup: function ($that) {
      var self = this;

      self.getDom($that);
      self.initFFAnswers($that);
      self.redoSettings($that);
      self.buildShadeCarousel($that);
      self.setEvents($that);
    },

    initFFAnswers: function ($that) {
      if ($that.nodes.$quizSlide.length > 0) {
        $that.nodes.$modelsSlides.each(function (i) {
          var $answer = $(this);
          var answerIndex = i + 1;

          $answer.data('answer', answerIndex)
            .attr('data-answer', answerIndex)
            .data('answerKey', answerIndex)
            .attr('data-answer-key', answerIndex);
        });
      }
    },

    redoSettings: function ($that) {
      var self = this;

      self.modelsSettings.slidesToShow = !self.isMobile ? !self.isMedium ? 3 : 2 : 1;

      var initialSlide = self.modelsSettings.initialSlide;

      if (Boolean($that.nodes.$modelsCarousel.data('initialSlide')) && $that.nodes.$modelsCarousel.data('initialSlide') < $that.nodes.$modelsSlides.length) {
        initialSlide = $that.nodes.$modelsCarousel.data('initialSlide');
      }
      self.modelsSettings.initialSlide = initialSlide;
    },

    swapLayout: function ($that) {
      var self = this;

      self.redoSettings($that);
      $that.nodes.$modelsSlides.css({ width: '' }); // Remove inline width
      if ($that.nodes.$modelsCarousel.hasClass('slick-initialized')) {
        $that.nodes.$modelsCarousel.slick('unslick');
      }
      // Have to give some time after the Unison change is fired before rebuilding the slider
      setTimeout(function () {
        self.initModelsSlider($that, self.modelsSettings);
        self.setFormatterHeight($that);
      }, 50);
    },

    setEvents: function ($that) {
      var self = this;

      $that.nodes.$modelsSlides.find('img').once('image-load').on('load', function () {
        self.setFormatterHeight($that);
      });
      $that.nodes.$container.on('ff-slider.slidesVisible', function () {
        setTimeout(function () {
          self.setFormatterHeight($that);
        }, 0);
      });
      $that.nodes.$modelsCarousel.on('beforeChange', function (e, _slick, currentIndex, nextIndex) {
        $that.nodes.$modelsSlides.removeClass('slick-active-onload');
      }).on('ff-step-in-view', function () {
        var selectedSlide = $that.nodes.$modelsCarousel.data('currentSelected') - 1 || self.modelsSettings.initialSlide;

        $that.nodes.$modelsCarousel.slick('slickGoTo', selectedSlide);
      }).on('ff-quiz-reset-quiz', function (e, index) {
        self.resetModelsCarousel($that);
      });
      $that.nodes.$modelsSlides.once('models-slide').on('click', function () {
        var $this = $(this);
        var $slickSlide = $this.closest('.slick-slide');
        var currentIndex = $slickSlide.data('slickIndex');

        self.highlightSelected($that.nodes.$modelsSlides.eq(currentIndex), $that);
        self.selectShadeSlide($that, currentIndex, true);
      });
    },

    resetModelsCarousel: function ($that) {
      var self = this;
      var modelsInitialSlide = $that.nodes.$modelsCarousel.data('initialSlide');
      var modelsShowSlides = $that.nodes.$modelsCarousel[0].slick.options.slidesToShow;

      $that.nodes.$modelsCarousel
        .removeClass('touched')
        .data('currentSelected', '')
        .slick('slickGoTo', modelsInitialSlide);
      self.selectShadeSlide($that, modelsInitialSlide);

      $that.nodes.$modelsSlides
        .slice(modelsInitialSlide, modelsShowSlides + modelsInitialSlide)
        .addClass('slick-active-onload');
    },

    keepSelected: function ($that, index, maxVisible) {
      var currentHighlight = $that.nodes.$modelsCarousel.data('currentSelected') - 1;
      var maxVisibleIndex = index + maxVisible - 1;

      if (currentHighlight > index && currentHighlight < maxVisibleIndex) {
        return true;
      }

      return false;
    },

    checkIfMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['medium'], 10);

      return currentBpWidth < bPlargeUp;
    },

    checkIfMedium: function () {
      var self = this;
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      // Need to decrease 1 from the large breakpoint to allow iPad landscape trigger it
      var bPlargeUp = parseInt(Unison.fetch.all()['mediumLandscape'], 10);

      if (currentBpWidth === 0 || self.isMobile) {
        return false;
      }

      return currentBpWidth < bPlargeUp;
    },

    buildShadeCarousel: function ($that) {
      var self = this;
      var shades = [];

      $that.nodes.$modelsSlides.each(function () {
        shades.push($(this).data('slideShadeHex'));
      });
      $that.nodes.$shadeCarousel.data('shades', shades);
      if (shades.length === $that.nodes.$modelsSlides.length) {
        self.generateShadeSlider($that);

        return;
      }
      self.initModelsSlider($that, self.modelsSettings);
    },

    initModelsSlider: function ($that, settings) {
      var self = this;
      var maxSlickGoTo = $that.nodes.$modelsSlides.length - settings.slidesToShow;

      $that.nodes.$modelsCarousel.data('maxSlickGoTo', maxSlickGoTo);
      var $firstSlideImage = $that.nodes.$modelsCarousel.find('img').first();

      self.initializeSlick($that.nodes.$modelsCarousel, settings);

      if ($firstSlideImage.length > 0 && $firstSlideImage[0].complete) {
        self.setFormatterHeight($that);
      }
    },

    generateShadeSlider: function ($that) {
      var self = this;
      var $shadeSlideMock = $('<div class="foundation-finder__shade-slide js-foundation-finder__shade-slide"></div>');
      var $shadeSlides = $();

      $that.nodes.$shadeCarousel.data('shades').forEach(function (shade) {
        var $shadeSlide = $shadeSlideMock.clone(true).css({ 'background-color': shade });

        $shadeSlides = $shadeSlides.add($shadeSlide);
      });

      $that.nodes.$shadeSlides = $shadeSlides;
      $that.nodes.$shadeCarousel.append($shadeSlides);

      var shadeSliderSettings = self.shadeSettings;

      shadeSliderSettings.slidesToShow = $that.nodes.$shadeCarousel.data('shades').length,

      self.initShadeSlider($that);
      self.initModelsSlider($that, self.modelsSettings);
      self.setFormatterHeight($that);
    },
    setFormatterHeight: function ($that) {
      if ($that.nodes.$quiz.data('layout') === 'accordion') {
        return;
      }
      $that.css({ height: $that.nodes.$shadeCarousel.outerHeight(true) + $that.nodes.$modelsCarousel.outerHeight(true) });
      $that.nodes.$container.trigger('ff-slider.redoHeight');
    },
    initShadeSlider: function ($that) {
      var self = this;
      var steps = $that.nodes.$shadeSlides.length - 1;
      var increment = 100;
      var start = self.modelsSettings.initialSlide * increment; // Use initialSlide as start for the rangeSlider

      if ($that.nodes.$shadeCarousel.length === 0) {
        return;
      }

      $that.nodes.$shadeCarousel.data('stepIncrement', increment);

      noUiSlider.create($that.nodes.$shadeCarousel[0], {
        start: [start],
        step: 1,
        direction: site.direction.isRTL ? 'rtl' : 'ltr',
        range: {
          min: [0],
          max: [steps * increment]
        }
      });
      $that.nodes.$shadeCarousel[0].noUiSlider.on('slide', function (values) {
        var val = values[0];
        var closestStep = self.getClosestStep(val, increment);

        self.setPointerBackground($that, $that.nodes.$shadeCarousel.data('shades')[closestStep]);
      });
      $that.nodes.$shadeCarousel[0].noUiSlider.on('change', function (values) {
        var val = values[0];
        var closestStep = self.getClosestStep(val, increment);

        if (val !== closestStep) {
          $that.nodes.$shadeCarousel.val(closestStep * increment);
          self.selectModelSlide($that, closestStep);
          $that.nodes.$shadeCarousel.data('selectedStepIndex', closestStep);
          self.selectShadeSlide($that, closestStep);
        }
      });
      self.setRangeSliderBackground($that);
      self.selectShadeSlide($that, self.modelsSettings.initialSlide);
      $that.nodes.$modelsCarousel.removeClass('touched');
    },

    selectModelSlide: function ($that, index) {
      var maxSlickGoTo = $that.nodes.$modelsCarousel.data('maxSlickGoTo');
      var modelsIndex = index > maxSlickGoTo ? maxSlickGoTo : index;

      $that.nodes.$modelsCarousel.slick('slickGoTo', modelsIndex);
    },

    selectShadeSlide: function ($that, index, modelSelect) {
      var self = this;

      if (modelSelect) {
        $that.nodes.$shadeCarousel[0].noUiSlider.set(index * $that.nodes.$shadeCarousel.data('stepIncrement'));
      }

      self.highlightSelected($that.nodes.$modelsSlides.eq(index), $that);
      self.setPointerBackground($that, $that.nodes.$shadeCarousel.data('shades')[index]);
    },

    correctPointerPosition: function ($that, index) {
      var $rangePointer = $that.nodes.$shadeCarousel.find('.noUi-handle');
      var isLast = index === $that.nodes.$shadeCarousel.data('shades').length - 1;

      if (isLast) {
        $rangePointer.css({ 'left': -$rangePointer.outerWidth(true) });
      } else {
        $rangePointer.css({ 'left': '' });
      }
    },

    setPointerBackground: function ($that, shade) {
      var $rangePointer = $that.nodes.$shadeCarousel.find('.noUi-handle');

      $rangePointer.css({ 'background': shade });
    },

    setRangeSliderBackground: function ($that) {
      var shadesStr = $that.nodes.$shadeCarousel.data('shades').join(',');
      var linear_gradient_direction = site.direction.isRTL ? 'left' : 'right';

      $that.nodes.$shadeCarousel.css({
        'background-image': 'linear-gradient(to ' + linear_gradient_direction + ',' + shadesStr + ' )'
      });
    },

    getClosestStep: function (val, increment) {
      var lower = parseInt(val / increment);
      var position = parseInt(val % increment);
      var closest = lower + 1;

      if (position <= increment / 2) {
        closest = lower;
      }

      return closest;
    },

    highlightSelected: function ($answer, $that) {
      var $selectedAnswer = $('.slick-track>div.selected-answer');

      $answer.trigger('ff-quiz-select-answer');
      if ($selectedAnswer.length > 0) {
        $selectedAnswer.removeClass('selected-answer');
      }
      $answer.closest('.slick-slide').addClass('selected-answer');
      $that.nodes.$modelsCarousel.addClass('touched').data('currentSelected', $answer.data('answerKey'));
      if ($that.nodes.$modelsCarousel.hasClass('slick-initialized') && !$answer.closest('.slick-slide').hasClass('slick-active')) {
        if ($answer.closest('.slick-slide').next('.slick-active-onload,.slick-active').length > 0) {
          $that.nodes.$modelsCarousel.slick('slickPrev');
        }
        if ($answer.closest('.slick-slide').prev('.slick-active-onload,.slick-active').length > 0) {
          $that.nodes.$modelsCarousel.slick('slickNext');
        }
      }
    },

    initializeSlick: function ($carousel, settings) {
      $carousel.slick(settings);
      $carousel.find('.slick-slide').slice(settings.initialSlide, settings.slidesToShow + settings.initialSlide).addClass('slick-active-onload');
    }
  };
})(jQuery);
